import { render, staticRenderFns } from "./IconSvgSettings.vue?vue&type=template&id=5acd56a5&scoped=true&"
import script from "./IconSvgSettings.vue?vue&type=script&lang=js&"
export * from "./IconSvgSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd56a5",
  null
  
)

export default component.exports